<template lang="pug">
v-container(fluid class="tw-m-0 tw-p-0 tw-pb-1" )
    div( class="tw-bg-white tw-rounded tw-border tw-border-gray-lighten-2 w-full tw-p-0 tw-m-0 " :class="{ 'tw-opacity-50' : loading, active: isActive }")
        v-row( align="start" class="")
            v-col(class="my-2 ml-4")
                v-row(no-gutters align="center" justify="space-between")
                    v-col(class=" tw-font-semibold tw-text-gray-700 tw-capitalize contactTitle")
                        span() {{ item.name }} 
                        span() {{ item.last_name }}
                v-row(no-gutters justify="space-between")
                    v-col(cols="auto" class="tw-mt-0 tw-mb-2")
                        span( class="tw-text-sm") {{ item.email }}
                v-row(no-gutters class=" tw-font-light tw-text-sm" align="center" justify="space-between")
                    v-col(cols="auto")
                        span()
                            v-icon(small class="pr-1") mdi-phone-classic
                            | {{ item.phone }}
            v-col(cols="auto" class=" my-1 mr-1")
                v-row(justify="end" align-content="space-between")   
                    v-col(cols="auto")
                        v-btn(v-if="action" icon plain tile width="20" height="5"  :ripple="false"  @click="remove(item.id)" :disabled="loading"  )
                            v-icon( color="grey darken-3") mdi-delete-forever
                v-row(no-gutters class="pt-4")
                    v-col( v-if="item.pivot && item.pivot.type" cols="auto")
                        v-chip( small outlined color="indigo" class="" )
                            span(class="tw-text-indigo-lighten-1 tw-font-bold" ) {{ item.pivot.type }}        
</template>
<script>
export default {
    props:{
        item: {
            type: Object,
            default: null
        },
        action: {
            type: String,
            default: null
        },
        entityType: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            loading: false
        }
    }, 
    computed:{
        isActive(){
            if (this.$store.getters['contacts/current_contact'] && this.item.id == this.$store.getters['contacts/current_contact'].id){
                return true
            } else {
                return false
            }
        }
    },
    methods: {
        remove(id){
            if(this.action == 'delete') {
                this.loading=true
                this.$store.dispatch('contacts/delete', id)
                .then((response) => {
                    
                })
                .catch((error) => {
                    commit('SET_ERROR', error, {root: true})
                })
            }
            if(this.action == 'unlink'){
                this.loading = true
                this.$store.dispatch( this.entityType + '/contacts/unlink', id)
                .then((response) => {
                })
                .catch((error) => {
                    this.loagind = false
                    commit('SET_ERROR', error, {root: true})
                })
            }
        }
    },
}
</script>

<style lang="stylus" scoped>
.active
    @apply tw-bg-indigo-lighten-5
    @apply tw-border-indigo-lighten-4

.active .contactTitle
    @apply tw-text-indigo-accent-2;
    @apply tw-font-bold;
</style>